import { Link, useSearchParams } from 'react-router';
import { useContacts } from '../../queries/ContactQueries';
import AppLayout from '../../components/AppLayout';
import { FaPlus } from 'react-icons/fa';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import ContactRosterTable from '../../components/ContactRosterTable';

export default function Contacts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get('view') || 'active';

  const { isPending, isError, data, error } = useContacts(view);
  return (
    <AppLayout>
      <div className='mb-8 w-full'>
        <div className='grid grid-cols-3 gap-1 max-md:grid-cols-1'>
          <div className='max-md:order-2 max-md:mb-4'>
            <div className='flex items-center text-xs font-bold uppercase max-md:justify-center'>
              View:
              <button
                name='view'
                className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
                  view == 'active' ? 'underline' : ''
                }`}
                onClick={() => setSearchParams({ view: 'active' })}
              >
                Active
              </button>
              <button
                name='view'
                className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
                  view == 'archived' ? 'underline' : ''
                }`}
                onClick={() => setSearchParams({ view: 'archived' })}
              >
                Archived
              </button>
              <button
                name='view'
                className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
                  view == 'all' ? 'underline' : ''
                }`}
                onClick={() => setSearchParams({ view: 'all' })}
              >
                All
              </button>
            </div>
          </div>
          <div className='flex items-start justify-center'>
            <h3 className='text-center text-2xl dark:text-gray-300'>
              Contacts
            </h3>
            <Link
              to='/add-contact'
              className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
            >
              <div className='flex items-center gap-2'>
                <FaPlus /> Add
              </div>
            </Link>
          </div>
        </div>
        <ShowPending isPending={isPending} />
        <ShowError isError={isError} error={error} />
        {data && <ContactRosterTable contacts={data} key={data?.length} />}
      </div>
    </AppLayout>
  );
}
